module.exports = __webpack_public_path__ + "img/9.d8d45fef.jpg";